import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';
import { useCallback, useState } from 'react';
import { useKeyboardShortcut } from '@zurich/common/hooks';
import { NMPKeyboardShortcuts } from '@zurich/common/types';
import { libsUiDataNames } from '@zurich/test/testdatanames';
import { Button } from '../Button';
import { Dialog } from '../Dialog';
import { SummaryTable } from '../SummaryTable';
export function ShortcutKeyLegend({ dialogTitle, shortCuts, }) {
    const [open, setOpen] = useState(false);
    const handleModal = useCallback(() => setOpen(!open), [open]);
    const ariaShortcutKeys = useKeyboardShortcut({
        callback: handleModal,
        key: NMPKeyboardShortcuts.LEGEND,
        translationPrefix: 'shortcuts.legend',
        dependency: true,
        options: { isModalOpen: open },
    });
    const onClose = () => {
        setOpen(false);
    };
    const onOpen = () => {
        setOpen(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { "data-name": libsUiDataNames.shortcutKeyLegend.button, "aria-keyshortcuts": ariaShortcutKeys, onClick: onOpen, "aria-label": "Shortcut modal button", children: _jsx(KeyboardCommandKeyIcon, {}) }), _jsx(Dialog, { dialogTitle: dialogTitle, onClose: onClose, open: open, children: _jsx(SummaryTable, { rows: shortCuts }) })] }));
}
